/* =============================================================================
 * M.M.LaFleur — the PDP sale label: place it, or suppress it.
 *
 * "Labor Day Sale $215" belongs beside "$299 $269", not as a separate line
 * lower down the buy column. Read together they are one statement about what
 * this product costs; read apart, the sale price looks like an unrelated
 * announcement that happens to contain a number.
 *
 * WHY THIS IS A DOM MOVE AND NOT MARKUP
 * -------------------------------------
 * The label is produced by snippets/mm_pdp_subtitle.liquid, invoked from
 * mm_color_row.liquid — the only seam available without editing
 * sections/mm_product.liquid, which is ~70KB and has no patch operation on the
 * Admin API, so every edit retransmits the whole file.
 *
 * The price block is a separate section block rendered earlier in that same
 * file. There is no Liquid route from one to the other, and CSS cannot help:
 * `order` can reposition a flex child but cannot put one element INSIDE
 * another, and the label has to be inside .mm-pdp-price to share its baseline.
 *
 * PRIVATE SALE LINE (Sept 22 2026)
 * --------------------------------
 * "$160 on Private Sale" ([data-mm-sale-line]) is moved to sit directly UNDER
 * the price row — after .mm-pdp-price, above the star rating — as its own
 * line, so the sale is stated once, right beneath the price.
 *
 * SUPPRESSION (v4.7.3: the list comes from the admin)
 * ---------------------------------------------------
 * Retired campaign wording is edited in Content → Metaobjects → Promo:
 * Settings → "Hidden label wording". snippets/mm_product_media.liquid
 * publishes it as window.__mmSuppressedLabels (lower-cased) on every PDP,
 * and the product card reads the same list, so the grid and the PDP agree.
 * FALLBACK is the v4.7.2 list, used only if that variable is missing.
 *
 * MATCHED AS A SUBSTRING, CASE-INSENSITIVE. The tag carries a price that
 * changes per product — "Labor Day Sale $263", "Labor Day Sale $215" — so an
 * exact match would need one entry per price point.
 * ========================================================================== */

(function () {
  "use strict";

  /* Platter re-injects footer scripts around a Barba container swap. */
  if (window.__mmSaleLabelBound) return;
  window.__mmSaleLabelBound = true;

  var FALLBACK = ["labor day", "save 20%"];

  /* Read on every call rather than once at bind time: the variable is written
     by an inline script on the PDP, and after a Barba swap it may arrive after
     this file has already bound. */
  function list() {
    var l = window.__mmSuppressedLabels;
    if (!Array.isArray(l)) return FALLBACK;
    return l.map(function (s) { return String(s || "").toLowerCase().trim(); })
            .filter(function (s) { return s.length > 0; });
  }

  function suppressed(text) {
    var haystack = (text || "").toLowerCase();
    return list().some(function (needle) {
      return haystack.indexOf(needle) !== -1;
    });
  }

  function placeLabel() {
    var label = document.querySelector("[data-mm-sale-label]");
    if (!label) return;

    if (suppressed(label.textContent)) {
      /* Removed outright rather than hidden. A display:none label is still read
         by a screen reader and still copied with the page. */
      if (label.parentNode) label.parentNode.removeChild(label);
      return;
    }

    var price = document.querySelector(".mm-pdp-price");
    if (!price) return;

    /* Already done — nothing to do, and re-appending would be a no-op that
       still churns layout. */
    if (label.parentElement === price) return;

    price.appendChild(label);
  }

  function placeLine() {
    var line = document.querySelector("[data-mm-sale-line]");
    if (!line) return;

    var price = document.querySelector(".mm-pdp-price");
    if (!price || !price.parentNode) return;

    /* Already directly after the price row. */
    if (price.nextElementSibling === line) return;

    price.parentNode.insertBefore(line, price.nextSibling);
    line.setAttribute("data-mm-sale-line-placed", "true");
  }

  function place() {
    placeLabel();
    placeLine();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", place);
  } else {
    place();
  }

  /* Barba replaces <main> without firing an event this can listen for, and a
     colourway swap re-renders the buy column in place. Both land here. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = null;
        place();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}());
